/** One server tick. Everything in the game world advances on this beat. */
export const TICK_MS = 600;

/** Wire protocol version. Bump when a message shape changes incompatibly. */
export const PROTOCOL_VERSION = 1;

/** How far (in tiles, Chebyshev distance) a player can see other actors and resource changes. */
export const VIEW_RADIUS = 32;

/** Interest-management chunk size in tiles. */
export const CHUNK = 16;

/** Fog-of-war reveal radius around a player, in tiles. */
export const REVEAL_RADIUS = 9;
export const LANTERN_REVEAL_RADIUS = 13;

/** Exploration xp earned per newly revealed tile. */
export const XP_PER_REVEALED_TILE = 0.3;

export const BASE_INV_SLOTS = 24;
export const MAX_LEVEL = 99;

/** Base walking speed in tiles per tick (RS-style "run" is 2). */
export const BASE_TILES_PER_TICK = 2;

/** Length limits applied by the server; the client mirrors them for UX only. */
export const NAME_MIN = 3;
export const NAME_MAX = 12;
export const CHAT_MAX = 120;

/** Water surface height in world units. */
export const WATER_LEVEL = 0;

/** Length of one in-game day in seconds. Server (NPC schedules) and client (sky) both use it. */
export const DAY_LENGTH_S = 720;
/** Hours of play before a character can trade with other players (cuts throwaway scam and bot accounts). */
export const TRADE_MIN_PLAY_HOURS = 2;
/** How close two players must stand to trade. */
export const TRADE_RANGE = 3;
/** Where in the day the world starts (0 = dawn). */
export const DAY_START = 0.08;
/** Time of day 0..1 for a given tick. */
export const dayTime = (tick: number, tickMs = TICK_MS) => ((tick * tickMs) / (DAY_LENGTH_S * 1000) + DAY_START) % 1;
/** NPCs who keep a house are indoors during this part of the day. */
export const isNight = (t: number) => t >= 0.55 && t < 0.94;
